export const metaAnalyticsEvents = {
	SIGNUP_REQUEST: 'CompleteRegistration',
	CREDITS_OVER: 'Lead',
	BEGIN_CHECKOUT: 'InitiateCheckout',
	PURCHASE_SUCCESSFULL: 'Purchase',
};
